import {DamageType, EquipmentType} from "./tcr";

export const availableDamagesForEquipments = new Map<EquipmentType, DamageType[]>();

availableDamagesForEquipments.set(EquipmentType.AGGREGATE, [
    DamageType.SCRATCHED,
    DamageType.BENT,
    DamageType.TORN,
    DamageType.LEAKAGE,
    DamageType.CRACKED,
    DamageType.BROKEN,
    DamageType.DENT,
    DamageType.MISSING,
    DamageType.OUT_OF_ORDER
]);
availableDamagesForEquipments.set(EquipmentType.TARPAULIN, [
    DamageType.SCRATCHED,
    DamageType.BENT,
    DamageType.TORN,
    DamageType.LEAKAGE,
    DamageType.CRACKED,
    DamageType.BROKEN,
    DamageType.DENT,
    DamageType.MISSING,
    DamageType.OUT_OF_ORDER
]);
availableDamagesForEquipments.set(EquipmentType.SIDE_BOARD, [
    DamageType.SCRATCHED,
    DamageType.BENT,
    DamageType.LEAKAGE,
    DamageType.CRACKED,
    DamageType.BROKEN,
    DamageType.DENT,
    DamageType.MISSING,
    DamageType.OUT_OF_ORDER
]);
availableDamagesForEquipments.set(EquipmentType.LEG, [
    DamageType.SCRATCHED,
    DamageType.BENT,
    DamageType.LEAKAGE,
    DamageType.CRACKED,
    DamageType.BROKEN,
    DamageType.DENT,
    DamageType.MISSING,
    DamageType.OUT_OF_ORDER
]);
availableDamagesForEquipments.set(EquipmentType.WHEEL, [
    DamageType.SCRATCHED,
    DamageType.BENT,
    DamageType.LEAKAGE,
    DamageType.CRACKED,
    DamageType.BROKEN,
    DamageType.DENT,
    DamageType.MISSING,
    DamageType.OUT_OF_ORDER
]);
availableDamagesForEquipments.set(EquipmentType.LIGHT, [
    DamageType.SCRATCHED,
    DamageType.BENT,
    DamageType.LEAKAGE,
    DamageType.CRACKED,
    DamageType.BROKEN,
    DamageType.DENT,
    DamageType.MISSING,
    DamageType.OUT_OF_ORDER
]);
availableDamagesForEquipments.set(EquipmentType.BICYCLE_PROTECTION, [
    DamageType.SCRATCHED,
    DamageType.BENT,
    DamageType.LEAKAGE,
    DamageType.CRACKED,
    DamageType.BROKEN,
    DamageType.DENT,
    DamageType.MISSING,
    DamageType.OUT_OF_ORDER
]);